import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { digestApi } from './digest-api.js';
import { toast } from './toast.js';

// #160: Abstand der Abfrage, solange ein Wochenbericht-Versand läuft.
export const DIGEST_POLL_MS = 3000;

// #160: Berichtshistorie. „Jetzt senden" kehrt sofort zurück, das Ergebnis steht erst später als
// Statuswechsel eines `running`-Laufs in der Historie — deshalb fragt sie nach, solange einer läuft,
// und hört danach von selbst auf.
export function useDigestHistory(projectId: string | undefined) {
  return useQuery({
    queryKey: ['digest-history', projectId],
    queryFn: () => digestApi.history(projectId!),
    enabled: Boolean(projectId),
    refetchInterval: (q) =>
      q.state.data?.some((r) => r.status === 'running') ? DIGEST_POLL_MS : false,
  });
}

// #160: „Jetzt senden"/„Erneut senden". Fehler laufen über den globalen Error-Toast
// (MutationCache.onError), die drei Erfolgsfälle bekommen je einen ehrlichen Text — „versendet"
// behauptet die Antwort nicht mehr.
export function useDigestSendNow(projectId: string | undefined) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => digestApi.send(projectId ?? ''),
    onSuccess: (res) => {
      if (res.result === 'started') toast.success(t('digest.sendStarted'));
      else if (res.result === 'already_running') toast.info(t('digest.sendAlreadyRunning'));
      else toast.info(t(`digest.sendSkipped.${res.reason ?? 'no_settings'}`));
      void queryClient.invalidateQueries({ queryKey: ['digest-history', projectId] });
    },
  });
}
